// extracted by mini-css-extract-plugin
export var icon = "_b7-3";
export var subtitle = "_b7-2";
export var title = "_b7-1";
export var value = "_b7-0";